export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const UPDATE_USER = 'update_user';
export const UPDATE_RENDER_STATUS = 'update_render_status';
// search  relevant 
export const ADD_KEYWORD_MUTATION = 'add_keyword_mutation';
export const REMOVE_KEYWORD_MUTATION = 'remove_keyword_mutation';
export const CONDITION_UPDATE_MUTATION = 'condition_update_mutation';
export const SORT_UPDATE_MUTATION = 'sort_select_mutation';
export const LAYOUT_UPDATE_MUTATION = 'layout_select_mutation';
export const INIT_PARAMS_MUTATION = 'init_params_mutation';
export const RESULT_UPDATE_MUTATION = 'result_update_mutation';
export const MAP_RESULT_UPDATE_MUTATION = 'map_result_update_mutation';
export const SOURCE_UPDATE_MUTATION = 'source_update_mutation';
export const SEARCH_RESET_MUTATION = 'search_reset_mutation';
export const PAGE_CHANGE_MUTATION = 'page_change_mutation';

export const MAP_CHANGE_MUTATION = 'map_change_mutation';
export const MAP_DRAWING_CHANGE_MUTATION = 'map_drawing_change_mutation';
export const ACTIVE_HOUSE_MARKER_MUTATION = 'active_house_marker_mutation';
export const OTHER_URL_QUERY_MUTATION = 'other_url_query_mutation';
export const QUICK_SEARCH_STATE_MUTATION = 'quick_search_state_mutation';
export const IS_BIG_MAP_MUTATION = 'is_big_map_mutation';
export const IS_GRID_OR_LIST_MUTATION = 'is_grid_or_list_mutation';
export const GRID_OR_LIST_TYPE_MUTATION = 'grid_or_list_mutation';
export const SEARCH_DATA_ACTION = 'search_data_action';
export const RESET_SEARCH_STORE = 'reset_search_store';
export const REMOVE_OUTLINE_REGION = 'remove_outline_region';
export const REMOVE_ALL_FILTERS = 'remove_all_filters';
export const SET_SNAPSHOT_MODE = 'SEARCH/SET_SNAPSHOT_MODE';
export const CENTER_COMPUTED_PRESET_FILTER = 'CENTER_COMPUTED_PRESET_FILTER';
export const CENTER_COMMIT_CONDITION = 'CENTER_COMMIT_CONDITION';
export const CENTER_UPDATE_CONDITION = 'CENTER_UPDATE_CONDITION';
export const SET_SEARCH_CONFIG_MAP = 'set_search_config_map';
export const CENTER_SET_SWITCH = 'CENTER_SET_SWITCH';
export const CENTER_DEL_SELECT = 'CENTER_DEL_SELECT';
export const CENTER_DEL_KEYWORD = 'CENTER_DEL_KEYWORD';
export const CENTER_DEL_INPUT_BOX = 'CENTER_DEL_INPUT_BOX';
export const CENTER_DEL_CONDITION = 'CENTER_DEL_CONDITION';
export const CENTER_OUTSIDE_FIELD = 'CENTER_OUTSIDE_FIELD';
export const CENTER_UPDATE_ARRAY_CONDITION = 'CENTER_UPDATE_ARRAY_CONDITION';
export const CENTER_UPDATE_INPUT_BOX_CONDITION =
    'CENTER_UPDATE_INPUT_BOX_CONDITION';
export const CENTER_UPDATE_DEFAULT_CONDITION =
    'CENTER_UPDATE_DEFAULT_CONDITION';
export const CENTER_SET_UI_CONFIG = 'CENTER_SET_UI_CONFIG';
export const CENTER_UPDATE_UI_CONFIG_ITEM = 'CENTER_UPDATE_UI_CONFIG_ITEM';
export const CENTER_UPDATE_KEYWORD_CONDITION =
    'CENTER_UPDATE_KEYWORD_CONDITION';
export const CENTER_DEL_SUGGESTION = 'CENTER_DEL_SUGGESTION';
export const CENTER_RESET_MUTATION = 'CENTER_RESET_MUTATION';
export const CENTER_RESET_CONDITION = 'CENTER_RESET_CONDITION';
export const CENTER_RESET_LOCATION = 'CENTER_RESET_LOCATION';
export const CENTER_RESET_ALL = 'CENTER_RESET_ALL';
export const IS_FROM_ALERT_MAIL = 'IS_FROM_ALERT_MAIL';
export const SET_PRESET_CONDITION_STATUS = 'SET_PRESET_CONDITION_STATUS';
export const SET_SORT_CONFIGS = 'SET_SORT_CONFIGS';
export const SET_GO_DETAIL = 'SET_GO_DETAIL';
export const NAVIGATOR_DETAIL = 'NAVIGATOR_DETAIL';
export const RESET_MOBILE_CONDITION = 'RESET_MOBILE_CONDITION';
//  Set the initial data of the page 
export const SET_PAGE = 'set_page';
export const SET_MODULEDATA = 'set_moduleData';
//  update page data 
// export const UPDATE_PAGE = 'update_page';
export const SET_CURRENT_LINK = 'set_currentLink';
export const HANDLE_GLOBAL_LNG_DATA = 'HANDLE_GLOBAL_LNG_DATA';
export const HANDLE_MODULE_LNG_DATA = 'HANDLE_MODULE_LNG_DATA';

//  Is the map loading 
export const UPDATE_IS_MAP_LOADING = 'update_isMapLoading';

//  renew isMobileSize
export const UPDATE_IS_MOBILE_SIZE = 'update_isMobileSize';
export const UPDATE_SEARCH_MOBILE_SIZE = 'UPDATE_SEARCH_MOBILE_SIZE';
// window.resize When recording the width and height of the visible area 
export const UPDATE_WINDOW_SIZE = 'UPDATE_WINDOW_SIZE';

// building relevant 
export const UPDATE_BUILDING_TAB = 'UPDATE_BUILDING_TAB';
export const UPDATE_BUILDING_INFO = 'UPDATE_BUILDING_INFO';
export const UPDATE_BUILDING_HOUSE_INFO = 'UPDATE_BUILDING_HOUSE_INFO';
export const SET_LISTING_DETAIL = 'SET_LISTING_DETAIL';
export const SET_WHITE_TEAM = 'SET_WHITE_TEAM';
//  Set whether it is a middle stage page 
export const UPDATE_SEARCH_CENTER = 'UPDATE_SEARCH_CENTER';

//  Internationalization related 
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_CURRENCY = 'SET_CURRENCY';

// chat
export const UPDATE_CHAT_POSITION = 'UPDATE_CHAT_POSITION';
export const RESET_CHAT_POSITION = 'RESET_CHAT_POSITION';

//  pass social Share Link Register or Login ， need to be tagged ，tagtype for login or register 
export const UPDATE_SOCIAL_TAG_TYPE = 'UPDATE_SOCIAL_TAG_TYPE';
